import { Navigate, Outlet } from 'react-router-dom'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'

import FeedbackFridgePage from '@pages/onboarding/FeedbackFridgePage'
import FeedbackGoalPage from '@pages/onboarding/FeedbackGoalPage'
import FeedbackProgressPage from '@pages/onboarding/FeedbackProgressPage'
import FeedbackSkillPage from '@pages/onboarding/FeedbackSkillPage'
import QuestionChallengePage from '@pages/onboarding/QuestionChallengePage'
import QuestionCookFrequencyPage from '@pages/onboarding/QuestionCookFrequencyPage'
import QuestionCravingPage from '@pages/onboarding/QuestionCravingPage'
import QuestionCuisinePage from '@pages/onboarding/QuestionCuisinePage'
import QuestionDietaryNeedPage from '@pages/onboarding/QuestionDietaryNeedPage'
import QuestionEatingStylePage from '@pages/onboarding/QuestionEatingStylePage'
import QuestionFoodCostsPage from '@pages/onboarding/QuestionFoodCostsPage'
import QuestionFridgeLookingPage from '@pages/onboarding/QuestionFridgeLookingPage'
import QuestionGroceryShopPage from '@pages/onboarding/QuestionGroceryShopPage'
import QuestionImportancePage from '@pages/onboarding/QuestionImportancePage'
import QuestionKitchenEquippedPage from '@pages/onboarding/QuestionKitchenEquippedPage'
import QuestionPeoplePage from '@pages/onboarding/QuestionPeoplePage'
import QuestionSkillLevelPage from '@pages/onboarding/QuestionSkillLevelPage'
import QuestionTimeSpendPage from '@pages/onboarding/QuestionTimeSpendPage'
import QuestionWastePage from '@pages/onboarding/QuestionWastePage'
import QuestionWhyMattersPage from '@pages/onboarding/QuestionWhyMattersPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="question-importance" replace />,
        index: true,
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionImportancePage />,
        path: 'question-importance',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackGoalPage />,
        path: 'feedback-goal',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionCookFrequencyPage />,
        path: 'question-cook-frequency',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionChallengePage />,
        path: 'question-challenge',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionWastePage />,
        path: 'question-waste',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionWhyMattersPage />,
        path: 'question-why-matters',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackProgressPage />,
        path: 'feedback-progress',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionEatingStylePage />,
        path: 'question-eating-style',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionDietaryNeedPage />,
        path: 'question-dietary-need',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionSkillLevelPage />,
        path: 'question-skill-level',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackSkillPage />,
        path: 'feedback-skill',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionTimeSpendPage />,
        path: 'question-time-spend',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionPeoplePage />,
        path: 'question-people',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionGroceryShopPage />,
        path: 'question-grocery-shop',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionFoodCostsPage />,
        path: 'question-food-costs',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionFridgeLookingPage />,
        path: 'question-fridge-looking',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackFridgePage />,
        path: 'feedback-fridge',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionCuisinePage />,
        path: 'question-cuisine',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionKitchenEquippedPage />,
        path: 'question-kitchen-equipped',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionCravingPage />,
        path: 'question-craving',
      },
    ],
  },
]

export default onboardingRoutes
